import { Component, ViewChild, OnInit, Output, EventEmitter} from '@angular/core';
import { BsModalComponent } from 'ng2-bs3-modal';
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import * as moment from 'moment';
/*Services */
import { TariffService, AppService } from '@services';
import { Tariff, ServicesParameters, Service } from '@models';

/*Config*/
import { CONFIG } from '../../../config';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'service-order-modal',
    templateUrl: './service-order-modal.component.html',
	styleUrls: ['./service-order-modal.component.scss']
})

export class ServiceOrderModalComponent  implements OnInit {
    submitForm = false;
    selectedDayDiff: number;
    @ViewChild('tariffModal') tariffModal: BsModalComponent;
	private maxRangeDay: number;
	@Output() onSendOrder = new EventEmitter<any>();
    public myDateRangePickerOptions: IMyDrpOptions = {
        dateFormat: 'dd.mm.yyyy',
        selectBeginDateTxt: 'Выберите начало периода',
        selectEndDateTxt: 'Выберите конец периода',
        showSelectDateText: true,
        monthSelector: true,
        showClearDateRangeBtn: false,
        editableDateRangeField: false,
        openSelectorOnInputClick: true,
        showClearBtn: true,
        showApplyBtn: false,
        yearSelector: false,
        disableSince: { year: 0, month: 0, day: 0 },
        dayLabels: CONFIG.dayLabels,
        monthLabels: CONFIG.monthLabels
      };
	modelDateRange;
    tariffList: Array<Tariff>;
    serviceName: string;
    paymentUrl = null;
    errorText = null;
    selectedTarif: Tariff;
    currentService: Service;
    constructor(
	  private tariffService: TariffService,
	  private appService: AppService
    ) {}

    ngOnInit() {
        this.initDateRange();
    }

    open(tariffList: Array<Tariff>, service:Service) {
		this.currentService = service;
		if(this.currentService.serviceType=="freezing" && this.currentService.parameters.maxFreezeInDays){
			this.maxRangeDay =  parseInt(this.currentService.parameters.maxFreezeInDays)
		}else{
			this.maxRangeDay = null;
		}
		this.selectedTarif = null;
		this.paymentUrl = null;
		this.modelDateRange = null;
		this.initDateRange();
		this.tariffList = tariffList;
		this.errorText = null;
		this.selectedDayDiff  = null;
		this.tariffModal.open();
        
    }

    initDateRange() {
		const date = new Date();
		const copy = this.getCopyOfOptions();
		copy.disableUntil = {
		  year: date.getFullYear(),
		  month: date.getMonth() + 1,
		  day: date.getDate()
		};
	
		this.myDateRangePickerOptions = copy;
	}
    onDateRangeChanged(event?: IMyDateRangeModel) {
        console.log(event)
        this.modelDateRange = {
            beginDate:null,
            endDate: null
        }
		this.modelDateRange.beginDate = event.beginDate;
		this.modelDateRange.endDate = event.endDate;
		const fromMoment = moment.utc({
		  year: this.modelDateRange.beginDate.year,
		  month: this.modelDateRange.beginDate.month - 1,
		  date: this.modelDateRange.beginDate.day
		});
	
		const toMoment = moment.utc({
		  year: this.modelDateRange.endDate.year,
		  month: this.modelDateRange.endDate.month - 1,
		  date: this.modelDateRange.endDate.day
    	});
    	let daysDiff = Math.abs(fromMoment.diff(toMoment, 'days'))+1;
  
    	this.selectedDayDiff =  parseInt(this.currentService.parameters.roamingRatePerDay)*daysDiff;
  }
  sendOrder(){
    console.log( this.modelDateRange)
    if(this.submitForm){
      return false;
    }
    this.errorText =null;
    if( !this.selectedTarif){
      this.errorText = "Укажите номер SIM-карты";
      return false;
    }
    if( !this.modelDateRange){
      this.errorText = "Выберите период оказания услуги";
      return false;
    }
    this.submitForm = true;
    const fromMoment = moment.utc({
		  year: this.modelDateRange.beginDate.year,
		  month: this.modelDateRange.beginDate.month - 1,
		  date: this.modelDateRange.beginDate.day
		});
	
		const toMoment = moment.utc({
		  year: this.modelDateRange.endDate.year,
		  month: this.modelDateRange.endDate.month - 1,
		  date: this.modelDateRange.endDate.day
		});
	
		const userDateTimeOffset = this.appService.userTimezoneOffset();
		const from  = moment(fromMoment).startOf('day').unix() + (userDateTimeOffset * 60 * 60);
		//const from = fromMoment.startOf('day').subtract(userDateTimeOffset, 'h').unix();
		const to = toMoment.endOf('day').subtract(userDateTimeOffset, 'h').unix();


        const copy = this.getCopyOfOptions();
        copy.disableSince = {
			year: 0,
			month: 0,
			day:0,
		};
		this.myDateRangePickerOptions = copy;

        console.log(from,to)
        console.log(this.selectedTarif)
        console.log(this.currentService.serviceType)

        this.serviceOrder(this.selectedTarif.number, this.currentService.serviceType,from, to);
  }
  serviceOrder(number: string, serviceType: string, startServiceDate: number, endServiceDate: number) {
    this.tariffService.seriveceOrder(number, serviceType, startServiceDate, endServiceDate)
      .subscribe( response => {
		console.log(response)
		this.onSendOrder.emit()
        if ( response.paymentUri && response.paymentUri.length > 0) {
          this.paymentUrl = response.paymentUri;
        }else{
          this.close()
        }
   
        this.submitForm = false;
      },
      error => {
        this.submitForm = false;
          let errorTariff = 'Ошибка при отправке заявки';
          if (error.error.errorMessage) {
            errorTariff = error.error.errorMessage;
          }
          this.errorText = errorTariff;
          console.log(error);
      });
  }

    
  onDateSelected(event) {
      if(this.maxRangeDay){
        const selectedDay = new Date(event.date.year, event.date.month - 1, event.date.day);

        const date =   this.addDays(selectedDay, this.maxRangeDay);
        const copy = this.getCopyOfOptions();
        copy.disableSince = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
        };

        this.myDateRangePickerOptions = copy;
      }
       
  }
    
	addDays(date, days) {
		const result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
  	}
  	clickPay(){
    	this.close()
  	}

	getCopyOfOptions(): IMyDrpOptions {
		return JSON.parse(JSON.stringify(this.myDateRangePickerOptions));
  	}
    
  	close() {
		this.onSendOrder.emit()
    	this.tariffModal.close();
  	}

}



// WEBPACK FOOTER //
// ./src/app/view/modal/service-order-modal/service-order-modal.component.ts